import changeOne from './change-one'
import copyOf from './copy-of'
import i18n from './i18n'
import filterMenu from './filter-menu'
import megatrend from './megatrend'
import macrotrend from './macrotrend'

export default {
    changeOne,
    copyOf,
    i18n,
    filterMenu,
    megatrend,
    macrotrend
}
